import { EMortgageBankApprove, ICreateMessageRequest } from '../../../repositories/demand/v4/create-message';
import { TMappedAnswersState } from '../types';
import { merge } from 'ramda';

/** Добавляет обязательные значения по умолчанию */
export const createRequestPayload = (state: TMappedAnswersState): ICreateMessageRequest => {
  return merge(
    {
      isBankDeposit: false,
      isHasOffer: false,
      isMortgageInitialPayment: false,
      isReadyToLower: false,
      mortgageBankApprove: EMortgageBankApprove.No,
      source: 'request-form-realtor',
    },
    state,
  );
};
